import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class BasisMailingBillsService extends BaseService {
  protected baseUrl = '/basis/notification/mailing/bills';
}
